module.exports = __webpack_public_path__ + "static/media/bg.854d3e16.png";